export const MAX_WIDTH = 880;
export const MAX_HEIGHT = 660;
